import { render, staticRenderFns } from "./MyOrganizationSurveys.vue?vue&type=template&id=628af25d"
import script from "./MyOrganizationSurveys.vue?vue&type=script&lang=js"
export * from "./MyOrganizationSurveys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports